/**
 * projectPage_SearchesSection_MainBlock_Container_Component.tsx
 *
 * Project Page - "Explore Search Results" section - Main Block Component
 *
 *
 */




import React from "react";

import {
    ProjectPage_SearchesSection_SearchesAndFoldersList_Component,
    ProjectPage_SearchesSection_SearchesAndFoldersList_Component__All_SearchSelectionData,
    ProjectPage_SearchesSection_SearchesAndFoldersList_Component__Expand_All_Folders__ShowSearchDetailsTo_Global_Force,
    ProjectPage_SearchesSection_SearchesAndFoldersList_Component__Selected_Searches_Data_Object,
    ProjectPage_SearchesSection_SearchesAndFoldersList_Component_Update_Selected_ProjectSearchIds,
    ProjectPage_SearchesSection_SearchesAndFoldersList_Component_Update_Selected_ProjectSearchIds_Params
} from "page_js/data_pages/other_data_pages/project_page/project_page_main_page_react_based/jsx/projectPage_SearchesSection_SearchesAndFoldersList_Component";
import {reportWebErrorToServer} from "page_js/common_all_pages/reportWebErrorToServer";
import {
    ProjectPage_SearchesSection_Open_DataPages_PeptideProteinMod,
    projectPage_SearchesSection_Open_DataPages_PeptideProteinMod__Initialize
} from "page_js/data_pages/other_data_pages/project_page/project_page_main_page_react_based/js/projectPage_SearchesSection_Open_DataPages_PeptideProteinMod";
import {DataPages_LoggedInUser_CommonObjectsFactory} from "page_js/data_pages/data_pages_common/dataPages_LoggedInUser_CommonObjectsFactory";
import {ProjectPage_SearchesAdmin} from "page_js/data_pages/other_data_pages/project_page/project_page_main_page_react_based/js/projectPage_SearchesAdmin";
import {ProjectPage_SearchesAdmin_DeleteSearch_Overlay_Component__SingleSearchEntry} from "page_js/data_pages/other_data_pages/project_page/project_page_main_page_react_based/jsx/projectPage_SearchesAdmin_DeleteSearch_Overlay_Component";
import {
    Search_Tags_SelectSearchTags_Component,
    Search_Tags_SelectSearchTags_Component_SearchTagData_Root,
    Search_Tags_SelectSearchTags_Component_SingleSearchTag_Entry,
    Search_Tags_SelectSearchTags_Component_SingleSearchTagCategory_Entry
} from "page_js/data_pages/search_tags__display_management/search_tags_SelectSearchTags_Component/search_Tags_SelectSearchTags_Component";
import {limelight__CompareStrings_CaseInsensitive_LocaleCompareWIthCaseInsensitiveParam} from "page_js/common_all_pages/limelight__CompareStrings_CaseInsensitive_LocaleCompareWIthCaseInsensitiveParam";
import {
    CommonData_LoadedFromServerFor_Project_SearchesSearchTagsFolders_Result_Root
} from "page_js/data_pages/common_data_loaded_from_server__for_project_or_project_search_ids__searches_search_tags_folders/commonData_LoadedFromServerFor_Project_OrFrom_ProjectSearchIds__SearchesSearchTagsFolders";
import {ProjectPage_SearchesSection_MainBlock_Container_SessionStorage_SaveGet} from "page_js/data_pages/other_data_pages/project_page/project_page_main_page_react_based/jsx/projectPage_SearchesSection_MainBlock_Container_SessionStorage_SaveGet";
import {ProjectPage_ROOT_Container_Containing_MultipleSections_Component__Get_searchesSearchTagsFolders_Result_Root__Function} from "page_js/data_pages/other_data_pages/project_page/project_page_main_page_react_based/project_page_ReactParts_ROOT_Component/projectPage_ROOT_Container_Containing_MultipleSections_Component";
import {Search_Tags_SelectSearchTags_DisplaySelectedTagsAndCategories_Component} from "page_js/data_pages/search_tags__display_management/search_tags_SelectSearchTags_Component/search_Tags_SelectSearchTags_DisplaySelectedTagsAndCategories_Component";
import {
    Tag_Filter_Expression_Builder_Grouped_Component, Tag_Filter_Expression_Builder_Grouped_Component__Expression,
    Tag_Filter_Expression_Builder_Grouped_Component__Seed_Group
} from "page_js/data_pages/search_tags__display_management/tag_filter_expression_builder_grouped_component/tag_Filter_Expression_Builder_Grouped_Component";
import {Tag_Filter_Expression_Preview_Component} from "page_js/data_pages/search_tags__display_management/tag_filter_expression_builder_grouped_component/tag_Filter_Expression_Preview_Component";
import {SearchTags_TagLookupMaps} from "page_js/data_pages/search_tags__display_management/searchTags_TagLookupMaps";
import {Search_DisplayVerbose_Value_StoreRetrieve_In_SessionStorage} from "page_js/data_pages/common__search_display_verbose_value_store_session_storage/search_DisplayVerbose_Value_StoreRetrieve_In_SessionStorage";
import {Search_Tags_Selections_Object} from "page_js/data_pages/search_tags__display_management/search_Tags_Selections_Object";
import { limelight__ReloadPage_Function } from "page_js/common_all_pages/limelight__ReloadPage_Function";
import {
    SearchDetailsAndFilterBlock_MainPage_SearchDetails_AllUsers__GetDataFromServer_Result__Root__HolderObject_Class
} from "page_js/data_pages/search_details_block__project_search_id_based/js/searchDetailsAndFilterBlock_MainPage_SearchDetails_AllUsers__GetDataFromServer";
import {
    limelight_Tooltip_React_Extend_Material_UI_Library__Main__Common_Properties__For_FollowMousePointer,
    Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component
} from "page_js/common_all_pages/tooltip_React_Extend_Material_UI_Library/limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component";
import {
    limelight__TooltipAddition_Component_ControlClick_OR_CommandClick_ToOpenInNewTab
} from "page_js/common_all_pages/limelight__TooltipAddition_Component_ControlClick_OR_CommandClick_ToOpenInNewTab";
import {
    Tooltip__green_question_mark_in_circle__tooltip_on_hover__Component
} from "page_js/common_all_pages/tooltip__green_question_mark_in_circle__tooltip_on_hover__react_component/tooltip__green_question_mark_in_circle__tooltip_on_hover__react_component";
import {
    tooltip__green_question_mark_in_circle__tooltip_on_hover__COMMON_MESSAGE_Search_Tags_VerboseView_Checkbox_react_component
} from "page_js/common_all_pages/tooltip__green_question_mark_in_circle__tooltip_on_hover__react_component/tooltip__green_question_mark_in_circle__tooltip_on_hover__COMMON_MESSAGE_Search_Tags_VerboseView_Checkbox_react_component";

/**
 *
 */
export interface ProjectPage_SearchesSection_MainBlock_Component_Props {

    //  force_Rerender_EmptyObjectReference_EmptyObjectReference:  Bypass all shouldComponentUpdate and render current value
    force_Rerender_EmptyObjectReference: object  //  All child components need to compare this object reference for display updating message since a newer force_Rerender_EmptyObjectReference object may come down while the child component is getting data to refresh

    //  force_ReloadFromServer_EmptyObjectReference:  Reload all data from server and display that data.  Display "Loading" message.
    force_ReloadFromServer_EmptyObjectReference: object  //  All child components need to compare this object reference for display updating message since a newer force_Rerender_EmptyObjectReference object may come down while the child component is getting data to refresh

    projectIdentifier : string
    projectIsLocked: boolean
    get_searchesSearchTagsFolders_Result_Root__Function: ProjectPage_ROOT_Container_Containing_MultipleSections_Component__Get_searchesSearchTagsFolders_Result_Root__Function
    dataPages_LoggedInUser_CommonObjectsFactory_ForSearchDetails: DataPages_LoggedInUser_CommonObjectsFactory
    projectPage_SearchesAdmin: ProjectPage_SearchesAdmin

    update_force_ReloadFromServer_EmptyObjectReference_Callback: () => void

    searchDetails_AllUsers__GetDataFromServer_Result__Root__HolderObject: SearchDetailsAndFilterBlock_MainPage_SearchDetails_AllUsers__GetDataFromServer_Result__Root__HolderObject_Class

    update_force_ReRender_EmptyObjectReference_Callback: () => void
}

/**
 *
 */
interface ProjectPage_SearchesSection_MainBlock_Component_State {

    expand_All_Folders__ShowSearchDetailsTo_Global_Force?: ProjectPage_SearchesSection_SearchesAndFoldersList_Component__Expand_All_Folders__ShowSearchDetailsTo_Global_Force

    selected_Searches_Data_Object?: ProjectPage_SearchesSection_SearchesAndFoldersList_Component__Selected_Searches_Data_Object;  // Pushed up on change from child component

    compareButtonsDisabled? : boolean;
    allSearches_InSelection_ContainProteins?: boolean
    copy_move_ButtonsDisabled?: boolean

    projectSearchIds_ToDisplay_FilteredIfNeeded__Null_IfNoFiltering?: Set<number>   //  null if no filtering
    folderIds_ToDisplay_FilteredIfNeeded__Null_IfNoFiltering?: Set<number>          //  null if no filtering

    search_Tags_SelectSearchTags_Component_SearchTagData_Root?: Search_Tags_SelectSearchTags_Component_SearchTagData_Root

    show_LoadingMessage_InitialLoad?: boolean
    show_UpdatingMessage?: boolean

    showNoSearchesMessage_NoSearchesLoadedFromServer?: boolean
    showNoSearchesMessage_NoSearches_AfterPossibleFiltering?: boolean

    show_SearchTag_Categories: boolean

    //  Which tag filter is active -- false/undefined = basic "Filter On Tags:", true = Advanced grouped filter.  Either/or.
    use_Advanced_TagFilter?: boolean

    force_Rerender?: object
}

/**
 *
 */
export class ProjectPage_SearchesSection_MainBlock_Component extends React.Component< ProjectPage_SearchesSection_MainBlock_Component_Props, ProjectPage_SearchesSection_MainBlock_Component_State > {

    private _compare_Scan_File_to_Searches_Clicked_BindThis = this._compare_Scan_File_to_Searches_Clicked.bind(this);
    private _compare_Stats_QC_Clicked_BindThis = this._compare_Stats_QC_Clicked.bind(this);
    private _compare_Peptides_Clicked_BindThis = this._compare_Peptides_Clicked.bind(this);
    private _compare_Proteins_Clicked_BindThis = this._compare_Proteins_Clicked.bind(this);
    private _compare_Mods_Clicked_BindThis = this._compare_Mods_Clicked.bind(this);

    private _copySearches_Clicked_BindThis = this._copySearches_Clicked.bind(this);
    private _deleteSearches_Clicked_BindThis = this._deleteSearches_Clicked.bind(this);
    private _bulk_set_update_TagsOnSearches_BindThis = this._bulk_set_update_TagsOnSearches.bind(this)
    private _manageTagsInProject_BindThis = this._manageTagsInProject.bind(this);
    // private _moveSearches_Clicked_BindThis = this._moveSearches_Clicked.bind(this);
    private _organizeSearchesButton_Clicked_BindThis = this._organizeSearchesButton_Clicked.bind(this);
    private _openFilterOverridesOverlay_Clicked_BindThis = this._openFilterOverridesOverlay_Clicked.bind(this);
    private _expand_All_Button_Clicked_BindThis = this._expand_All_Button_Clicked.bind(this);
    private _collapse_All_Button_Clicked_BindThis = this._collapse_All_Button_Clicked.bind(this);
    private _selectAll_Button_Clicked_BindThis = this._selectAll_Button_Clicked.bind(this)

    private _callback_updateSelected_Searches_BindThis = this._callback_updateSelected_Searches.bind(this);
    private _callback_SearchChanged_BindThis = this._callback_SearchChanged.bind(this);
    private _callback_SearchDeleted_BindThis = this._callback_SearchDeleted.bind(this);
    private _callback_FolderRenamedOrDeleted_BindThis = this._callback_FolderRenamedOrDeleted.bind(this);

    private _DO_NOT_CALL_VALIDATES_FunctionSignatures() {

        const _callback_updateSelected_Searches : ProjectPage_SearchesSection_SearchesAndFoldersList_Component_Update_Selected_ProjectSearchIds = this._callback_updateSelected_Searches;
    }

    private _searchesSearchTagsFolders_Result_Root: CommonData_LoadedFromServerFor_Project_SearchesSearchTagsFolders_Result_Root

    private _search_Tags_Selections_Object: Search_Tags_Selections_Object = Search_Tags_Selections_Object.createEmptyInstance()

    //  Seed for the Advanced builder ( from the basic selection when switching, or from session storage on load ).
    //  Each group carries its own groupOperator;  _advanced_TagFilter_Initial_BetweenOperator is the single
    //  independent operator that combines the groups.
    private _advanced_TagFilter_InitialSeed: Array<Tag_Filter_Expression_Builder_Grouped_Component__Seed_Group> = []
    private _advanced_TagFilter_Initial_BetweenOperator: 'AND' | 'OR' = 'AND'

    //  Bumped to force the Advanced builder to remount ( React key ) when we reset it from outside -- e.g. the
    //  "clear" in the summary.  The builder holds its own state, so a remount is how the parent resets it.
    private _advanced_Builder_RemountCounter = 0

    //  Number of searches in the WHOLE project that have each tag, keyed by tagId ( shown as "( N )" in the
    //  tag-picker overlay ).  Computed once when the search/tag data is (re)built.
    private _searchesPerTagId_Map : Map<number, number> = new Map()

    //  tagId -> tag entry and category id -> label lookups for the advanced builder/preview.  Built once when
    //  the search/tag data is (re)built ( see _process_New__... ) and passed down as an instance, so the maps
    //  are not rebuilt per render.
    private _searchTags_TagLookupMaps : SearchTags_TagLookupMaps = new SearchTags_TagLookupMaps( undefined )

    private _searchName_SearchId_Filter_UserInput = ""

    private _projectPage_SearchesSection_ROOT_Container_SessionStorage_SaveGet: ProjectPage_SearchesSection_MainBlock_Container_SessionStorage_SaveGet

    /**
     * Set/Change to force a change in the child component
     */
    private _forceUpdate_search_Selected_InProgress : ProjectPage_SearchesSection_SearchesAndFoldersList_Component__All_SearchSelectionData

    /**
     *
     */
    constructor(props: ProjectPage_SearchesSection_MainBlock_Component_Props) {
        super(props)

        this._projectPage_SearchesSection_ROOT_Container_SessionStorage_SaveGet = new ProjectPage_SearchesSection_MainBlock_Container_SessionStorage_SaveGet({ projectIdentifierFromURL: props.projectIdentifier })
        this._projectPage_SearchesSection_ROOT_Container_SessionStorage_SaveGet.initialize()

        {
            const current__SearchName_SearchId_FilterValue = this._projectPage_SearchesSection_ROOT_Container_SessionStorage_SaveGet.get_current__SearchName_SearchId_FilterValue()
            if ( current__SearchName_SearchId_FilterValue ) {
                this._searchName_SearchId_Filter_UserInput = current__SearchName_SearchId_FilterValue
            }
        }

        const show_SearchTag_Categories = Search_DisplayVerbose_Value_StoreRetrieve_In_SessionStorage.get_Value()

        this.state = {
            selected_Searches_Data_Object: null, // Nothing selected if null
            expand_All_Folders__ShowSearchDetailsTo_Global_Force: null,
            compareButtonsDisabled: true,
            copy_move_ButtonsDisabled: true,
            show_LoadingMessage_InitialLoad: true,
            show_UpdatingMessage: false,
            showNoSearchesMessage_NoSearchesLoadedFromServer: false,
            showNoSearchesMessage_NoSearches_AfterPossibleFiltering: false,
            show_SearchTag_Categories
        }
    }

    /**
     *
     */
    componentDidMount() {
        try {
            projectPage_SearchesSection_Open_DataPages_PeptideProteinMod__Initialize();

            this._searchesAndFolders_GetFromFunctionPassedFromParent()

        } catch (e) {
            reportWebErrorToServer.reportErrorObjectToServer({
                errorException : e
            });
            throw e;
        }
    }

    componentDidUpdate(prevProps: Readonly<ProjectPage_SearchesSection_MainBlock_Component_Props>, prevState: Readonly<ProjectPage_SearchesSection_MainBlock_Component_State>, snapshot?: any) {
        if ( prevProps.force_ReloadFromServer_EmptyObjectReference !== this.props.force_ReloadFromServer_EmptyObjectReference ) {
            //  Reload Data

            this._searchesAndFolders_GetFromFunctionPassedFromParent();
        }
    }

    /**
     *
     */
    private _searchesAndFolders_GetFromFunctionPassedFromParent() : void {

        const searchesSearchTagsFolders_Result_Root__Function__Result = this.props.get_searchesSearchTagsFolders_Result_Root__Function({})

        if ( searchesSearchTagsFolders_Result_Root__Function__Result.searchesSearchTagsFolders_Result_Root ) {

            this._process_New__searchesSearchTagsFolders_Result_Root({
                searchesSearchTagsFolders_Result_Root: searchesSearchTagsFolders_Result_Root__Function__Result.searchesSearchTagsFolders_Result_Root
            })

            return; // EARLY RETURN
        }

        if ( ! searchesSearchTagsFolders_Result_Root__Function__Result.searchesSearchTagsFolders_Result_Root_Promise ) {
            throw Error("this.props.get_searchesSearchTagsFolders_Result_Root__Function({}): Not return searchesSearchTagsFolders_Result_Root__Function__Result.searchesSearchTagsFolders_Result_Root or searchesSearchTagsFolders_Result_Root__Function__Result.searchesSearchTagsFolders_Result_Root_Promise")
        }

        this.setState({ show_UpdatingMessage: true })

        searchesSearchTagsFolders_Result_Root__Function__Result.searchesSearchTagsFolders_Result_Root_Promise.catch(reason => {

            this.setState({ show_UpdatingMessage: false, show_LoadingMessage_InitialLoad: false })
        })
        searchesSearchTagsFolders_Result_Root__Function__Result.searchesSearchTagsFolders_Result_Root_Promise.then(searchesSearchTagsFolders_Result_Root => { try {

            this._process_New__searchesSearchTagsFolders_Result_Root({ searchesSearchTagsFolders_Result_Root })
        } catch (e) {
            reportWebErrorToServer.reportErrorObjectToServer({
                errorException: e
            });
            throw e;
        }})
    }

    /**
     *
     * @param searchesSearchTagsFolders_Result_Root
     */
    private _process_New__searchesSearchTagsFolders_Result_Root(
        {
            searchesSearchTagsFolders_Result_Root
        } : {
            searchesSearchTagsFolders_Result_Root: CommonData_LoadedFromServerFor_Project_SearchesSearchTagsFolders_Result_Root
        }
    ) {
        this._searchesSearchTagsFolders_Result_Root = searchesSearchTagsFolders_Result_Root;

        const searchTagStrings_AllSearches_ArraySorted = Array.from(searchesSearchTagsFolders_Result_Root.get_all_SearchTags_InProject_Iterator());
        searchTagStrings_AllSearches_ArraySorted.sort((a, b) => {
            return limelight__CompareStrings_CaseInsensitive_LocaleCompareWIthCaseInsensitiveParam( a.tagString, b.tagString )
        })

        {  //   Set Current Search Tag Filters from the stored entries in Browser Session Storage if any exist and for current project id

            const fromSessionStorage_SearchTagIds_Selected = this._projectPage_SearchesSection_ROOT_Container_SessionStorage_SaveGet.get_SearchTagIds_Selected();
            if ( fromSessionStorage_SearchTagIds_Selected ) {

                //   this._searchTag_Filter_SelectedTagIds set to default empty at object instantiation so only continue if have saved values

                //   Then remove filters for tags NOT currently in the list of searches.  Then Set that as the current search tag filters.

                const filterFor_OR_AND_or_NOT = (inputFilterTagIds: ReadonlySet<number>) : Set<number> => {
                    if ( ! inputFilterTagIds ) {
                        return new Set()
                    }

                    const output_Filter_TagIds = new Set( inputFilterTagIds )

                    for ( const searchTagId_Selected_Input of inputFilterTagIds ) {
                        if ( ! searchesSearchTagsFolders_Result_Root.get_SearchTags_InProject_For_TagId( searchTagId_Selected_Input ) ) {
                            output_Filter_TagIds.delete( searchTagId_Selected_Input );
                        }
                    }
                    return output_Filter_TagIds;
                }

                //   Then Set that as the current search tag filters.

                this._search_Tags_Selections_Object = new Search_Tags_Selections_Object({
                    searchTagIdsSelected_Boolean__OR: filterFor_OR_AND_or_NOT(fromSessionStorage_SearchTagIds_Selected.searchTagIdsSelected_Boolean__OR),
                    searchTagIdsSelected_Boolean__AND: filterFor_OR_AND_or_NOT(fromSessionStorage_SearchTagIds_Selected.searchTagIdsSelected_Boolean__AND),
                    searchTagIdsSelected_Boolean__NOT: filterFor_OR_AND_or_NOT(fromSessionStorage_SearchTagIds_Selected.searchTagIdsSelected_Boolean__NOT)
                });
            }

        }

        //  Load the Advanced ( grouped ) tag filter from session storage, dropping any tags no longer in the project.
        //  If a non-empty advanced filter exists, default to Advanced mode.
        let use_Advanced_TagFilter = false;
        {
            const stored_Advanced = this._projectPage_SearchesSection_ROOT_Container_SessionStorage_SaveGet.get_Advanced_TagFilter();
            if ( stored_Advanced ) {
                const filtered_Groups: Array<Tag_Filter_Expression_Builder_Grouped_Component__Seed_Group> = [];
                for ( const group of stored_Advanced.groups ) {
                    const literals = group.literals.filter( lit => searchesSearchTagsFolders_Result_Root.get_SearchTags_InProject_For_TagId( lit.tagId ) );
                    if ( literals.length > 0 ) {
                        filtered_Groups.push( { literals, groupOperator: group.groupOperator } );
                    }
                }
                if ( filtered_Groups.length > 0 ) {
                    this._advanced_TagFilter_InitialSeed = filtered_Groups;
                    this._advanced_TagFilter_Initial_BetweenOperator = stored_Advanced.betweenGroups_Operator;
                    use_Advanced_TagFilter = true;
                }
            }
        }

        const searchTagCategory_Array_Filter_AllEntries: Array<Search_Tags_SelectSearchTags_Component_SingleSearchTagCategory_Entry> = []

        for ( const category_input of searchesSearchTagsFolders_Result_Root.get_all_SearchTagCategories_InProject_In_DisplayOrder() ) {
            const category_Result: Search_Tags_SelectSearchTags_Component_SingleSearchTagCategory_Entry = {
                category_id: category_input.category_id,
                category_label: category_input.category_label,
                label_Color_Font: category_input.label_Color_Font,
                label_Color_Background: category_input.label_Color_Background,
                label_Color_Border: category_input.label_Color_Border
            }
            searchTagCategory_Array_Filter_AllEntries.push(category_Result)
        }

        const searchTagEntries_Filter_AllEntries: Array<Search_Tags_SelectSearchTags_Component_SingleSearchTag_Entry> = []

        for (const tagEntry of searchTagStrings_AllSearches_ArraySorted) {

            searchTagEntries_Filter_AllEntries.push(tagEntry)
        }

        //  Count how many searches in the project have each tag ( shown as "( N )" next to each tag in the
        //  tag-picker overlay ).  One pass over all searches' tag id sets.
        {
            const searchesPerTagId_Map = new Map<number, number>()
            for ( const projectSearchId of searchesSearchTagsFolders_Result_Root.get_all_Searches_ProjectSearchIds_Set() ) {
                const searchData = searchesSearchTagsFolders_Result_Root.get_SearchData_For_ProjectSearchId( projectSearchId )
                if ( searchData && searchData.searchTagIds_Set ) {
                    for ( const tagId of searchData.searchTagIds_Set ) {
                        searchesPerTagId_Map.set( tagId, ( searchesPerTagId_Map.get( tagId ) ?? 0 ) + 1 )
                    }
                }
            }
            this._searchesPerTagId_Map = searchesPerTagId_Map
        }

        let showNoSearchesMessage_NoSearchesLoadedFromServer = false;

        if ( searchesSearchTagsFolders_Result_Root.is_NO_Searches_In_Project() ) {
            showNoSearchesMessage_NoSearchesLoadedFromServer = true;
        }

        const search_Tags_SelectSearchTags_Component_SearchTagData_Root: Search_Tags_SelectSearchTags_Component_SearchTagData_Root = {
            searchTagCategory_Array: searchTagCategory_Array_Filter_AllEntries, searchTag_Array: searchTagEntries_Filter_AllEntries
        }

        //  Build the tag/category lookup maps ONCE here ( same place as the per-tag count map ), passed down as
        //  an instance so the advanced builder/preview don't rebuild them on every render.
        this._searchTags_TagLookupMaps = new SearchTags_TagLookupMaps( search_Tags_SelectSearchTags_Component_SearchTagData_Root )

        this.setState({
            search_Tags_SelectSearchTags_Component_SearchTagData_Root,
            showNoSearchesMessage_NoSearchesLoadedFromServer,
            show_UpdatingMessage: false,
            show_LoadingMessage_InitialLoad: false,
            use_Advanced_TagFilter
        });

        this._searchesAndFolders_Update_FilterOnSearchTags()

    }

    /**
     * Translate the existing simple tag selections ( OR / AND / NOT buckets ) into the
     * grouped seed shape for the "Advanced" builder:
     *   - each AND tag  -> its own 1-tag group                       ( groups combined by the between-op )
     *   - each NOT tag  -> its own 1-tag negated group ( "NOT tag" )
     *   - the OR bucket -> a single group with groupOperator 'OR'
     * The groups are combined with the between-groups operator 'AND' ( see _switchTo_Advanced_TagFilter ), so
     * this preserves the basic filter's meaning exactly.
     * If there are no existing selections, returns [] and the builder shows the "Start building a tag filter"
     * empty-state callout ( no groups yet ).
     */
    private _build_Grouped_SeedGroups_From_ExistingSelections() : Array<Tag_Filter_Expression_Builder_Grouped_Component__Seed_Group> {

        const seedGroups : Array<Tag_Filter_Expression_Builder_Grouped_Component__Seed_Group> = [];

        const sel = this._search_Tags_Selections_Object;
        if ( sel ) {
            for ( const tagId of sel.searchTagIdsSelected_Boolean__AND ) {
                seedGroups.push( { literals: [ { tagId, negated: false } ], groupOperator: 'OR' } );
            }
            for ( const tagId of sel.searchTagIdsSelected_Boolean__NOT ) {
                seedGroups.push( { literals: [ { tagId, negated: true } ], groupOperator: 'OR' } );
            }
            if ( sel.searchTagIdsSelected_Boolean__OR.size > 0 ) {
                const literals = Array.from( sel.searchTagIdsSelected_Boolean__OR ).map( tagId => ( { tagId, negated: false } ) );
                seedGroups.push( { literals, groupOperator: 'OR' } );
            }
        }

        return seedGroups;
    }

    /**
     * Switch to the Advanced grouped filter -- seed the builder from the current basic
     * selection, then clear the basic selection.
     */
    private _switchTo_Advanced_TagFilter() : void {

        //  Capture the seed BEFORE clearing the basic selection.  Basic maps to OR-within-group / AND-between.
        this._advanced_TagFilter_InitialSeed = this._build_Grouped_SeedGroups_From_ExistingSelections();
        this._advanced_TagFilter_Initial_BetweenOperator = 'AND';

        //  Persist the advanced filter so a reload defaults to Advanced
        this._save_Advanced_TagFilter_ToSessionStorage( this._advanced_TagFilter_InitialSeed, this._advanced_TagFilter_Initial_BetweenOperator );

        //  Clear the basic tag filter
        this._search_Tags_Selections_Object = Search_Tags_Selections_Object.createEmptyInstance();
        this._searchesAndFolders_Update_FilterOnSearchTags();
        this._projectPage_SearchesSection_ROOT_Container_SessionStorage_SaveGet.
            update_SearchTagIds_Selected({ updated_SearchTagIds_Selected: this._search_Tags_Selections_Object });

        this.setState({ use_Advanced_TagFilter: true });
    }

    /**
     * Return to the basic filter -- discard/clear the advanced filter ( incl. session storage ).
     */
    private _switchTo_Basic_TagFilter() : void {

        this._advanced_TagFilter_InitialSeed = [];
        this._advanced_TagFilter_Initial_BetweenOperator = 'AND';
        this._projectPage_SearchesSection_ROOT_Container_SessionStorage_SaveGet.update_Advanced_TagFilter( null );

        //  Advanced now empty and basic empty => re-filter ( no tag filtering )
        this._searchesAndFolders_Update_FilterOnSearchTags();

        this.setState({ use_Advanced_TagFilter: false });
    }

    /**
     * Clear the advanced tag filter -- remove all groups ( back to the builder's pristine empty state ),
     * reset the between-groups operator, clear persistence, and re-run filtering.  Remounts the builder so its
     * own internal state resets.  Stays in Advanced mode ( parallels the basic "clear tag filters" ).
     */
    private _clearAdvancedTagFilter = () : void => {
        this._advanced_TagFilter_InitialSeed = [];
        this._advanced_TagFilter_Initial_BetweenOperator = 'AND';
        this._advanced_Builder_RemountCounter++;
        this._save_Advanced_TagFilter_ToSessionStorage( this._advanced_TagFilter_InitialSeed, this._advanced_TagFilter_Initial_BetweenOperator );
        this._searchesAndFolders_Update_FilterOnSearchTags();
        this.setState({ force_Rerender: {} });
    }

    /**
     * Save the advanced filter to session storage ( null/empty clears it ).
     */
    private _save_Advanced_TagFilter_ToSessionStorage(
        groups : ReadonlyArray<Tag_Filter_Expression_Builder_Grouped_Component__Seed_Group>,
        betweenGroups_Operator : 'AND' | 'OR'
    ) : void {

        const groups_Copy = groups.map( g => ( { groupOperator: g.groupOperator, literals: g.literals.map( l => ( { tagId: l.tagId, negated: l.negated } ) ) } ) );

        this._projectPage_SearchesSection_ROOT_Container_SessionStorage_SaveGet.update_Advanced_TagFilter(
            groups_Copy.length > 0 ? { betweenGroups_Operator, groups: groups_Copy } : null
        );
    }

    /**
     * The advanced filter is "active" ( used for filtering ) when it has at least one group -- whether that
     * group has tags or is empty.  An empty group blocks all searches ( see _advanced_TagFilter_Matches ), so
     * it must count as active.  The pristine "Start building a tag filter" state has NO groups ( seed == [] ),
     * so it is NOT active and all searches display.
     */
    private _isAdvanced_TagFilter_Active() : boolean {
        return this._advanced_TagFilter_InitialSeed.length > 0;
    }

    /**
     * True if the advanced filter contains any empty group ( a group with zero tags ).
     */
    private _advanced_TagFilter_HasEmptyGroup() : boolean {
        for ( const group of this._advanced_TagFilter_InitialSeed ) {
            if ( group.literals.length === 0 ) {
                return true;
            }
        }
        return false;
    }

    /**
     * Evaluate the advanced ( grouped ) expression against one search's tag id set.
     * Each group combines its literals with its OWN groupOperator;  the single betweenGroups_Operator combines
     * the groups.  A negated literal matches when the tag is ABSENT.
     */
    private _advanced_TagFilter_Matches( searchTagIds_Set : ReadonlySet<number> ) : boolean {

        //  An empty group makes the filter incomplete -- no searches pass until it is populated or removed.
        //  This is only reached when the advanced filter is active ( has >=1 tag ), so the pristine
        //  "Start building a tag filter" state ( no tags yet ) is unaffected and still displays all searches.
        if ( this._advanced_TagFilter_HasEmptyGroup() ) {
            return false;
        }

        const betweenOp = this._advanced_TagFilter_Initial_BetweenOperator;

        const nonEmptyGroups = this._advanced_TagFilter_InitialSeed.filter( g => g.literals.length > 0 );
        if ( nonEmptyGroups.length === 0 ) {
            return true;  //  no constraint
        }

        const groupResults = nonEmptyGroups.map( group => {
            const literalResults = group.literals.map( lit => {
                const present = searchTagIds_Set.has( lit.tagId );
                return lit.negated ? ( ! present ) : present;
            } );
            return ( group.groupOperator === 'AND' ) ? literalResults.every( r => r ) : literalResults.some( r => r );
        } );

        return ( betweenOp === 'AND' ) ? groupResults.every( r => r ) : groupResults.some( r => r );
    }

    /**
     * Filtering on
     */
    private _searchesAndFolders_Update_FilterOnSearchTags() : void {
        try {

            const advancedActive = this._isAdvanced_TagFilter_Active();

            if ( this._searchName_SearchId_Filter_UserInput.length === 0 && ( ! advancedActive ) && ( ! this._search_Tags_Selections_Object.is_any_selections() ) ) {
                //  NO Filtering on Search Name, Search Id, or Search Tags so just put this._searchesAndFolders_Unfiltered_FromWebservice in State

                this.setState({
                    projectSearchIds_ToDisplay_FilteredIfNeeded__Null_IfNoFiltering: null,
                    folderIds_ToDisplay_FilteredIfNeeded__Null_IfNoFiltering: null,
                    showNoSearchesMessage_NoSearches_AfterPossibleFiltering: this._searchesSearchTagsFolders_Result_Root.is_NO_Searches_In_Project()
                });

                return;  // EARLY RETURN
            }

            //  Create new Project Search Id Set, applying filtering

            const projectSearchIds_ToDisplay_FilteredIfNeeded__Null_IfNoFiltering = new Set<number>();

            for ( const projectSearchId of this._searchesSearchTagsFolders_Result_Root.get_all_Searches_ProjectSearchIds_Set() ) {

                const searchData = this._searchesSearchTagsFolders_Result_Root.get_SearchData_For_ProjectSearchId(projectSearchId);

                if ( ! searchData ) {
                    const msg = "this._searchesSearchTagsFolders_Result_Root.get_SearchData_For_ProjectSearchId(projectSearchId); returned NOTHING for projectSearchId: " + projectSearchId;
                    console.warn(msg)
                    throw Error(msg)
                }

                let foundAllFilteringOn = true;

                //   Filter on Search Name

                if ( this._searchName_SearchId_Filter_UserInput.length > 0 ) {
                    if ( ( ! searchData.searchName.toLocaleLowerCase().includes( this._searchName_SearchId_Filter_UserInput.toLocaleLowerCase() ) )
                        && ( ! searchData.searchId.toString().includes( this._searchName_SearchId_Filter_UserInput ) ) ) {

                        foundAllFilteringOn = false;
                    }
                }

                if ( foundAllFilteringOn ) {

                    //  Filter on Search Tags

                    if ( ! searchData.searchTagIds_Set ) {
                        const msg = "searchData.searchTagIds_Set NOT Populated for projectSearchId: " + projectSearchId;
                        console.warn(msg)
                        throw Error(msg)
                    }

                    if ( advancedActive ) {

                        //  Advanced ( grouped ) tag filtering
                        if ( ! this._advanced_TagFilter_Matches( searchData.searchTagIds_Set ) ) {
                            foundAllFilteringOn = false
                        }

                    } else {

                        {  //  Filter on the 'AND' filters
                            if ( this._search_Tags_Selections_Object.searchTagIdsSelected_Boolean__AND.size > 0 ) {
                                for ( const filterOn_SelectedTagId of this._search_Tags_Selections_Object.searchTagIdsSelected_Boolean__AND ) {
                                    if ( ! searchData.searchTagIds_Set.has( filterOn_SelectedTagId ) ) {
                                        foundAllFilteringOn = false
                                        break;
                                    }
                                }
                            }
                        }
                        if ( foundAllFilteringOn ) { //  Filter on the 'NOT' filters
                            if ( this._search_Tags_Selections_Object.searchTagIdsSelected_Boolean__NOT.size > 0 ) {
                                for ( const filterOn_SelectedTagId of this._search_Tags_Selections_Object.searchTagIdsSelected_Boolean__NOT ) {
                                    if ( searchData.searchTagIds_Set.has( filterOn_SelectedTagId ) ) {
                                        foundAllFilteringOn = false
                                        break;
                                    }
                                }
                            }
                        }
                        if ( foundAllFilteringOn ) { //  Filter on the 'OR' filters
                            if ( this._search_Tags_Selections_Object.searchTagIdsSelected_Boolean__OR.size > 0 ) {
                                let foundAny_Of_OR_Tags = false;
                                for ( const filterOn_SelectedTagId of this._search_Tags_Selections_Object.searchTagIdsSelected_Boolean__OR ) {
                                    if ( searchData.searchTagIds_Set.has( filterOn_SelectedTagId ) ) {
                                        foundAny_Of_OR_Tags = true
                                        break;
                                    }
                                }
                                if ( ! foundAny_Of_OR_Tags ) {
                                    foundAllFilteringOn = false
                                }
                            }
                        }
                    }
                }

                if ( foundAllFilteringOn ) {
                    projectSearchIds_ToDisplay_FilteredIfNeeded__Null_IfNoFiltering.add(projectSearchId);
                }
            }

            let noSearchesFound_Result = true;
            if ( projectSearchIds_ToDisplay_FilteredIfNeeded__Null_IfNoFiltering.size > 0 ) {
                noSearchesFound_Result = false;
            }

            const folderIds_ToDisplay_FilteredIfNeeded__Null_IfNoFiltering = new Set<number>()

            for ( const folderData of this._searchesSearchTagsFolders_Result_Root.get_allFolders_Data_InDisplayOrder() ) {

                for ( const projectSearchId_InFolder of folderData.searchesInFolder_ProjectSearchIds_InDisplayOrder ) {
                    if ( projectSearchIds_ToDisplay_FilteredIfNeeded__Null_IfNoFiltering.has( projectSearchId_InFolder ) ) {
                        folderIds_ToDisplay_FilteredIfNeeded__Null_IfNoFiltering.add(folderData.folderId)
                        break;
                    }
                }
            }

            this.setState({
                projectSearchIds_ToDisplay_FilteredIfNeeded__Null_IfNoFiltering,
                folderIds_ToDisplay_FilteredIfNeeded__Null_IfNoFiltering,
                showNoSearchesMessage_NoSearches_AfterPossibleFiltering: noSearchesFound_Result
            });

        } catch (e) {
            reportWebErrorToServer.reportErrorObjectToServer({
                errorException : e
            });
            throw e;
        }
    }

    /**
     * Number of searches that passed the current filters -- the size of the filtered project-search-id set
     * ( 0 when everything is filtered out ).  The set is null only when there is NO filtering, in which case
     * the "Filtering on ..." box ( where this count is shown ) is not rendered.
     */
    private _filtered_Searches_PassedCount() : number {
        const set = this.state.projectSearchIds_ToDisplay_FilteredIfNeeded__Null_IfNoFiltering;
        return set ? set.size : 0;
    }

    /**
     *
     * @param params
     * @private
     */
    private _callback_updateSelected_Searches(params : ProjectPage_SearchesSection_SearchesAndFoldersList_Component_Update_Selected_ProjectSearchIds_Params) : void {

        let compareButtonsDisabled = true;
        if ( params.selected_Searches_Data_Object.get_Number_Searches_Selected() > 1 ) {
            compareButtonsDisabled = false;
        }
        let copy_move_organize_ButtonsDisabled = true;
        if ( params.selected_Searches_Data_Object.is_ANY_Search_Selected() ) {
            copy_move_organize_ButtonsDisabled = false;
        }

        let allSearches_InSelection_ContainProteins = true

        for ( const projectSearchId of params.selected_Searches_Data_Object.get_ProjectSearchIds_Selected_In_SelectionOrder_IterableIterator() ) {

            const searchData_For_ProjectSearchId = this._searchesSearchTagsFolders_Result_Root.get_SearchData_For_ProjectSearchId( projectSearchId )
            if ( ! searchData_For_ProjectSearchId ) {
                const msg = "this._searchesSearchTagsFolders_Result_Root.get_SearchData_For_ProjectSearchId( projectSearchId ) returned NOTHING for projectSearchId FROM params.selected_Searches_Data_Object.get_ProjectSearchIds_Selected_In_SelectionOrder_IterableIterator()"
                console.warn(msg)
                throw Error(msg)
            }

            if ( searchData_For_ProjectSearchId.searchNotContainProteins ) {
                allSearches_InSelection_ContainProteins = false
                break
            }
        }


        this.setState({
            selected_Searches_Data_Object: params.selected_Searches_Data_Object,
            compareButtonsDisabled,
            allSearches_InSelection_ContainProteins,
            copy_move_ButtonsDisabled: copy_move_organize_ButtonsDisabled,
            force_Rerender: {}
        });
    }

    /**
     *
     */
    private _callback_SearchChanged() : void {

        if ( this.props.update_force_ReloadFromServer_EmptyObjectReference_Callback ) {

            this.props.update_force_ReloadFromServer_EmptyObjectReference_Callback()

            return; // EARLY RETURN
        }

        limelight__ReloadPage_Function() //  Fallback when no callback is available
    }

    /**
     *
     */
    private _callback_SearchDeleted() : void {

        if ( this.props.update_force_ReloadFromServer_EmptyObjectReference_Callback ) {

            this.props.update_force_ReloadFromServer_EmptyObjectReference_Callback()

            return; // EARLY RETURN
        }

        limelight__ReloadPage_Function() //  Fallback when no callback is available
    }

    /**
     *
     */
    private _callback_FolderRenamedOrDeleted() : void {

        if ( this.props.update_force_ReloadFromServer_EmptyObjectReference_Callback ) {

            this.props.update_force_ReloadFromServer_EmptyObjectReference_Callback()

            return; // EARLY RETURN
        }

        limelight__ReloadPage_Function() //  Fallback when no callback is available
    }

    /**
     *
     */
    private _compare_Scan_File_to_Searches_Clicked (event: React.MouseEvent<HTMLInputElement, MouseEvent> ){

        const ctrlKeyOrMetaKey = event.ctrlKey || event.metaKey;

        if ( ! this.state.selected_Searches_Data_Object ) {
            //  NO searches selected
            return; // EARLY RETURN
        }

        ProjectPage_SearchesSection_Open_DataPages_PeptideProteinMod.scanFileToSearch_View_OpenDataPage({
            selected_Searches_Data_Object: this.state.selected_Searches_Data_Object,
            searchesSearchTagsFolders_Result_Root: this._searchesSearchTagsFolders_Result_Root,
            ctrlKeyOrMetaKey
        })
    }

    /**
     *
     */
    private _compare_Stats_QC_Clicked (event: React.MouseEvent<HTMLInputElement, MouseEvent> ){

        const ctrlKeyOrMetaKey = event.ctrlKey || event.metaKey;

        if ( ! this.state.selected_Searches_Data_Object ) {
            //  NO searches selected
            return; // EARLY RETURN
        }

        ProjectPage_SearchesSection_Open_DataPages_PeptideProteinMod.qc_View_OpenDataPage({
            selected_Searches_Data_Object: this.state.selected_Searches_Data_Object,
            searchesSearchTagsFolders_Result_Root: this._searchesSearchTagsFolders_Result_Root,
            ctrlKeyOrMetaKey
        })
    }

    /**
     *
     */
    private _compare_Peptides_Clicked (event: React.MouseEvent<HTMLInputElement, MouseEvent> ){

        const ctrlKeyOrMetaKey = event.ctrlKey || event.metaKey;

        if ( ! this.state.selected_Searches_Data_Object ) {
            //  NO searches selected
            return; // EARLY RETURN
        }

        ProjectPage_SearchesSection_Open_DataPages_PeptideProteinMod.peptide_View_OpenDataPage({
            selected_Searches_Data_Object: this.state.selected_Searches_Data_Object,
            searchesSearchTagsFolders_Result_Root: this._searchesSearchTagsFolders_Result_Root,
            ctrlKeyOrMetaKey
        })
    }

    /**
     *
     */
    private _compare_Proteins_Clicked (event: React.MouseEvent<HTMLInputElement, MouseEvent> ){

        const ctrlKeyOrMetaKey = event.ctrlKey || event.metaKey;

        if ( ! this.state.selected_Searches_Data_Object ) {
            //  NO searches selected
            return; // EARLY RETURN
        }

        ProjectPage_SearchesSection_Open_DataPages_PeptideProteinMod.protein_View_OpenDataPage({
            selected_Searches_Data_Object: this.state.selected_Searches_Data_Object,
            searchesSearchTagsFolders_Result_Root: this._searchesSearchTagsFolders_Result_Root,
            ctrlKeyOrMetaKey
        })
    }

    /**
     *
     */
    private _compare_Mods_Clicked (event: React.MouseEvent<HTMLInputElement, MouseEvent> ){

        const ctrlKeyOrMetaKey = event.ctrlKey || event.metaKey;

        if ( ! this.state.selected_Searches_Data_Object ) {
            //  NO searches selected
            return; // EARLY RETURN
        }

        ProjectPage_SearchesSection_Open_DataPages_PeptideProteinMod.mod_View_OpenDataPage({
            selected_Searches_Data_Object: this.state.selected_Searches_Data_Object,
            searchesSearchTagsFolders_Result_Root: this._searchesSearchTagsFolders_Result_Root,
            ctrlKeyOrMetaKey
        })
    }

    /**
     *
     */
    private _copySearches_Clicked (event: React.MouseEvent<HTMLInputElement, MouseEvent> ) {

        if ( ! this.state.selected_Searches_Data_Object ) {
            //  NO searches selected
            return; // EARLY RETURN
        }

        this.props.projectPage_SearchesAdmin.openOverlay_ForCopySearches({
            projectSearchIdsSelected: new Set( this.state.selected_Searches_Data_Object.get_ProjectSearchIds_Selected_In_SelectionOrder_IterableIterator() ),
            projectIdentifier: this.props.projectIdentifier
        })
    }

    /**
     *
     */
    private _deleteSearches_Clicked (event: React.MouseEvent<HTMLInputElement, MouseEvent> ) {

        if ( ! this.state.selected_Searches_Data_Object ) {
            //  NO searches selected
            return; // EARLY RETURN
        }

        if ( ! this.state.selected_Searches_Data_Object.is_ANY_Search_Selected() ) {

            // No project search ids found to process

            return; // EARLY RETURN
        }

        const searchesToDelete: Array<ProjectPage_SearchesAdmin_DeleteSearch_Overlay_Component__SingleSearchEntry> = []

        for ( const projectSearchId of  this.state.selected_Searches_Data_Object.get_ProjectSearchIds_Selected_Additions_In_DisplayOrder() ) {

            const searchData = this._searchesSearchTagsFolders_Result_Root.get_SearchData_For_ProjectSearchId(projectSearchId);

            if ( ! searchData ) {
                const msg = "this._searchesSearchTagsFolders_Result_Root.get_SearchData_For_ProjectSearchId(projectSearchId); returned NOTHING for projectSearchId: " + projectSearchId;
                console.warn(msg)
                throw Error(msg)
            }

            searchesToDelete.push( searchData );
        }

        const deleteComplete_Callback = () => {

            //  In Parent component of Search List so after delete searches is complete just reload the page

            limelight__ReloadPage_Function()
        }

        this.props.projectPage_SearchesAdmin.deleteSearches({
            searchesToDelete,
            projectIdentifier: this.props.projectIdentifier,
            deleteComplete_Callback
        })
    }

    /**
     *
     */
    private _bulk_set_update_TagsOnSearches(event: React.MouseEvent<HTMLInputElement, MouseEvent> ) {

        if ( ! this.state.selected_Searches_Data_Object ) {
            //  NO searches selected
            return; // EARLY RETURN
        }

        if ( ! this.state.selected_Searches_Data_Object.is_ANY_Search_Selected() ) {

            // No project search ids found to process

            return; // EARLY RETURN
        }

        const tagsChangedOnSearches_Callback = () : void => {

            if ( this.props.update_force_ReloadFromServer_EmptyObjectReference_Callback ) {

                this.props.update_force_ReloadFromServer_EmptyObjectReference_Callback()

                return;  // EARLY RETURN
            }

            limelight__ReloadPage_Function()
        }

        this.props.projectPage_SearchesAdmin.openOverlay_For_Search_Tags_Manage_TagsForSearches({
            projectSearchIdsSelected: new Set( this.state.selected_Searches_Data_Object.get_ProjectSearchIds_Selected_In_SelectionOrder_IterableIterator() ),
            tagsChangedOnSearches_Callback
        })
    }

    /**
     *
     */
    private _manageTagsInProject(event: React.MouseEvent<HTMLInputElement, MouseEvent> ) {

        const tagsChanged_Callback = () : void => {

            if ( this.props.update_force_ReloadFromServer_EmptyObjectReference_Callback ) {

                this.props.update_force_ReloadFromServer_EmptyObjectReference_Callback()

                return;  // EARLY RETURN
            }

            limelight__ReloadPage_Function()
        }

        this.props.projectPage_SearchesAdmin.openOverlay_For_Search_Tags_Manage_TagsForProject({
            projectIdentifier: this.props.projectIdentifier,
            tagsChanged_Callback
        })
    }


    //  MOVE currently not supported so commented out

    /**
     *
     */
    // private _moveSearches_Clicked (event: React.MouseEvent<HTMLInputElement, MouseEvent> ) {
    //
    //     this.props.projectPage_SearchesAdmin.openOverlay_ForCopyMoveSearches({
    //         projectSearchIdsSelected: this.state.projectSearchIds_Selected_InProgress,
    //         projectIdentifier: this.props.projectIdentifier,
    //         doCopy: false,
    //         doMove: true
    //     })
    // }

    /**
     *
     */
    private _organizeSearchesButton_Clicked(event: React.MouseEvent<HTMLInputElement, MouseEvent> ) {

        const ctrlKeyOrMetaKey = event.ctrlKey || event.metaKey;

        const url = "d/pg/project-organize-searches/" + this.props.projectIdentifier

        if ( ctrlKeyOrMetaKey ) {

            window.open(url, "_blank", "noopener");

            return; // EARLY EXIT
        }

        window.location.href = url
    }

    /**
     *
     */
    private _openFilterOverridesOverlay_Clicked(event: React.MouseEvent<HTMLInputElement, MouseEvent> ) {

        this.props.projectPage_SearchesAdmin.set_ProjectWide_DefaultFilter_Cutoffs_Overrides.openSet_ProjectWide_DefaultFilter_Cutoffs_Overrides();
    }

    /**
     *
     */
    private _expand_All_Button_Clicked (event: React.MouseEvent<HTMLInputElement, MouseEvent> ) {

        this.setState({ expand_All_Folders__ShowSearchDetailsTo_Global_Force: { expand_All_Folders__ShowSearchDetails_Global_ForceToValue: true } });
    }

    /**
     *
     */
    private _collapse_All_Button_Clicked (event: React.MouseEvent<HTMLInputElement, MouseEvent> ) {

        this.setState({ expand_All_Folders__ShowSearchDetailsTo_Global_Force: { expand_All_Folders__ShowSearchDetails_Global_ForceToValue: false } });
    }

    /**
     *
     */
    private _selectAll_Button_Clicked( event: React.MouseEvent<HTMLButtonElement, MouseEvent> ) {

        //  Add all searches in project OR Add searches in project that meet filters

        //     Filtering using this.state.projectSearchIds_ToDisplay_FilteredIfNeeded__Null_IfNoFiltering

        const projectSearchIds_BeingSelected_Set: Set<number> = new Set()

        const search_Selected_InProgress = new ProjectPage_SearchesSection_SearchesAndFoldersList_Component__All_SearchSelectionData()

        { //  Process searches in folders
            const allFolders_Data_InDisplayOrder = this._searchesSearchTagsFolders_Result_Root.get_allFolders_Data_InDisplayOrder()
            if ( allFolders_Data_InDisplayOrder ) {
                for ( const folderData of allFolders_Data_InDisplayOrder ) {

                    if ( folderData.searchesInFolder_ProjectSearchIds_InDisplayOrder ) {
                        for ( const projectSearchId of folderData.searchesInFolder_ProjectSearchIds_InDisplayOrder ) {
                            if (
                                ( ! this.state.projectSearchIds_ToDisplay_FilteredIfNeeded__Null_IfNoFiltering )
                                || this.state.projectSearchIds_ToDisplay_FilteredIfNeeded__Null_IfNoFiltering.has( projectSearchId )
                            ) {
                                search_Selected_InProgress.add_For_ProjectSearchId_IfNotExists( projectSearchId )

                                projectSearchIds_BeingSelected_Set.add( projectSearchId )
                            }
                        }
                    }
                }
            }
        }
        { // Process searches
            const projectSearchIds_NOT_IN_ANY_Folder_InDisplayOrder = this._searchesSearchTagsFolders_Result_Root.get_searches_ProjectSearchIds_NOT_IN_ANY_Folder_InDisplayOrder()
            if ( projectSearchIds_NOT_IN_ANY_Folder_InDisplayOrder ) {
                for ( const projectSearchId of projectSearchIds_NOT_IN_ANY_Folder_InDisplayOrder ) {
                    if (
                        ( ! this.state.projectSearchIds_ToDisplay_FilteredIfNeeded__Null_IfNoFiltering )
                        || this.state.projectSearchIds_ToDisplay_FilteredIfNeeded__Null_IfNoFiltering.has( projectSearchId )
                    ) {
                        search_Selected_InProgress.add_For_ProjectSearchId_IfNotExists( projectSearchId )

                        projectSearchIds_BeingSelected_Set.add( projectSearchId )
                    }
                }
            }
        }

        const _SEARCH_SELECT_ALL_SEARCH_COUNT_ASK_USER_TO_CONFIRM = 20

        if ( projectSearchIds_BeingSelected_Set.size < _SEARCH_SELECT_ALL_SEARCH_COUNT_ASK_USER_TO_CONFIRM ) {

            this._selectAll_Button_PerformUpdate( { search_Selected_InProgress } )

            return
        }

        if ( window.confirm( "Select " + projectSearchIds_BeingSelected_Set.size + " Searches?" ) ) {

            this._selectAll_Button_PerformUpdate( { search_Selected_InProgress } )
        }
    }

    /**
     *
     */
    private _selectAll_Button_PerformUpdate(
        {
            search_Selected_InProgress
        } : {
            search_Selected_InProgress: ProjectPage_SearchesSection_SearchesAndFoldersList_Component__All_SearchSelectionData
        }
    ) {


        this._forceUpdate_search_Selected_InProgress = search_Selected_InProgress

        const selected_Searches_Data_Object = new ProjectPage_SearchesSection_SearchesAndFoldersList_Component__Selected_Searches_Data_Object({
            search_Selected_InProgress: search_Selected_InProgress,
            searchesSearchTagsFolders_Result_Root: this._searchesSearchTagsFolders_Result_Root
        })

        this._callback_updateSelected_Searches({ selected_Searches_Data_Object });

        this.setState({ force_Rerender: {} })
    }

    /////////////////

    /**
     *
     */
    render() {

        let searchCount_TotalOrFiltered: number = undefined

        if ( this.state.projectSearchIds_ToDisplay_FilteredIfNeeded__Null_IfNoFiltering ) {

            searchCount_TotalOrFiltered = this.state.projectSearchIds_ToDisplay_FilteredIfNeeded__Null_IfNoFiltering.size
        } else {

            const projectSearchIds_Set: Set<number> = new Set()

            if ( this._searchesSearchTagsFolders_Result_Root ) {

                { //  Process searches in folders

                    const allFolders_Data_InDisplayOrder = this._searchesSearchTagsFolders_Result_Root.get_allFolders_Data_InDisplayOrder()
                    if ( allFolders_Data_InDisplayOrder ) {
                        for ( const folderData of allFolders_Data_InDisplayOrder ) {

                            if ( folderData.searchesInFolder_ProjectSearchIds_InDisplayOrder ) {
                                for ( const projectSearchId of folderData.searchesInFolder_ProjectSearchIds_InDisplayOrder ) {
                                    if (
                                        ( ! this.state.projectSearchIds_ToDisplay_FilteredIfNeeded__Null_IfNoFiltering )
                                        || this.state.projectSearchIds_ToDisplay_FilteredIfNeeded__Null_IfNoFiltering.has( projectSearchId )
                                    ) {
                                        projectSearchIds_Set.add( projectSearchId )
                                    }
                                }
                            }
                        }
                    }
                }
                { // Process searches
                    const projectSearchIds_NOT_IN_ANY_Folder_InDisplayOrder = this._searchesSearchTagsFolders_Result_Root.get_searches_ProjectSearchIds_NOT_IN_ANY_Folder_InDisplayOrder()
                    if ( projectSearchIds_NOT_IN_ANY_Folder_InDisplayOrder ) {
                        for ( const projectSearchId of projectSearchIds_NOT_IN_ANY_Folder_InDisplayOrder ) {
                            if (
                                ( ! this.state.projectSearchIds_ToDisplay_FilteredIfNeeded__Null_IfNoFiltering )
                                || this.state.projectSearchIds_ToDisplay_FilteredIfNeeded__Null_IfNoFiltering.has( projectSearchId )
                            ) {
                                projectSearchIds_Set.add( projectSearchId )
                            }
                        }
                    }
                }
            }

            searchCount_TotalOrFiltered = projectSearchIds_Set.size
        }

        return (
            ( ! this._searchesSearchTagsFolders_Result_Root ) ? (
                <div>Loading Searches</div>

            ) : (
                <div>
                    { ( ! this.state.showNoSearchesMessage_NoSearches_AfterPossibleFiltering ) ? (

                        <div style={ { marginBottom: 10, whiteSpace: "nowrap" } }>

                            {/*  Expand All and Collapse All Buttons  */ }

                            <Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component
                                title={
                                    <span>
                                        Show Search Details for All Searches.
                                    </span>
                                }
                                { ...limelight_Tooltip_React_Extend_Material_UI_Library__Main__Common_Properties__For_FollowMousePointer() }
                            >
                                <input type="button" className="submit-button "
                                       value="Expand All"
                                       onClick={ this._expand_All_Button_Clicked_BindThis }
                                />
                            </Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component>
                            <span> </span>

                            <Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component
                                title={
                                    <span>
                                        Hide Search Details for All Searches.
                                    </span>
                                }
                                { ...limelight_Tooltip_React_Extend_Material_UI_Library__Main__Common_Properties__For_FollowMousePointer() }
                            >
                                <input className="submit-button " type="button"
                                       value="Collapse All"
                                       onClick={ this._collapse_All_Button_Clicked_BindThis }
                                />
                            </Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component>
                            <span> </span>

                            <Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component
                                title={

                                    ( ! this._searchName_SearchId_Filter_UserInput ) ? (
                                            <div style={ { padding: 6 } }>
                                                <div>
                                                    Select all the searches in the project.
                                                </div>
                                                <div style={ { marginTop: 5 } }>
                                                    Selecting { searchCount_TotalOrFiltered } searches.
                                                </div>
                                            </div>
                                    ) : (
                                        <div style={ { padding: 6 } }>
                                            <div>
                                                Select the filtered searches in the project.
                                            </div>
                                            <div style={ { marginTop: 5 } }>
                                                Selecting { searchCount_TotalOrFiltered } searches.
                                            </div>
                                        </div>
                                    )
                                }
                                { ...limelight_Tooltip_React_Extend_Material_UI_Library__Main__Common_Properties__For_FollowMousePointer() }
                            >
                                <button
                                    className="submit-button "
                                    onClick={ this._selectAll_Button_Clicked_BindThis }
                                >
                                    {
                                        this.props.projectPage_SearchesAdmin ? ( // Shorten button text when have buttons for Admin
                                            ( ! this._searchName_SearchId_Filter_UserInput ) ? (
                                                "Select All"
                                            ) : (
                                                "Select Filtered"
                                            ) ) : (
                                                // NOT Search Admin buttons so have longer button names here
                                            ( ! this._searchName_SearchId_Filter_UserInput ) ? (
                                                "Select All Searches"
                                            ) : (
                                                "Select Filtered Searches"
                                            )
                                        )
                                    }
                                </button>
                            </Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component>

                            {/*  Only For Logged In User  */ }
                            { ( this.props.dataPages_LoggedInUser_CommonObjectsFactory_ForSearchDetails ) ? (

                                <>
                                    { ( this.props.projectPage_SearchesAdmin ) ? (

                                        // Show since projectPage_SearchesAdmin is populated

                                        <React.Fragment>

                                            <span> </span>

                                            {/*  Copy Searches */ }

                                            <div style={ { position: "relative", display: "inline-block" } }>
                                                <Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component
                                                    title={
                                                        <span>
                                                            Click here to copy the selected searches to another project.
                                                        </span>
                                                    }
                                                    { ...limelight_Tooltip_React_Extend_Material_UI_Library__Main__Common_Properties__For_FollowMousePointer() }
                                                >
                                                    <input type="button" value="Copy Searches"
                                                           disabled={ this.state.copy_move_ButtonsDisabled }
                                                           onClick={ this._copySearches_Clicked_BindThis }
                                                    />
                                                </Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component>
                                                { ( this.state.copy_move_ButtonsDisabled ) ? (
                                                    // overlay when button is disabled to show tooltip
                                                    <Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component
                                                        title={
                                                            <span>
                                                                Click here to copy the selected searches to another
                                                                project.
                                                            </span>
                                                        }
                                                        { ...limelight_Tooltip_React_Extend_Material_UI_Library__Main__Common_Properties__For_FollowMousePointer() }
                                                    >
                                                        <div
                                                            style={ {
                                                                position: "absolute",
                                                                left: 0,
                                                                right: 0,
                                                                top: 0,
                                                                bottom: 0
                                                            } }
                                                        ></div>
                                                    </Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component>
                                                ) : null }
                                            </div>

                                            { ( ! this.props.projectIsLocked ) ? (

                                                //  NOT shown when project is locked

                                                <>
                                                    <span> </span>

                                                    {/*  Delete Searches */ }

                                                    <div style={ { position: "relative", display: "inline-block" } }>
                                                        <Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component
                                                            title={
                                                                <span>
                                                                    Click here to delete the selected searches.
                                                                </span>
                                                            }
                                                            { ...limelight_Tooltip_React_Extend_Material_UI_Library__Main__Common_Properties__For_FollowMousePointer() }
                                                        >
                                                            <input type="button" value="Delete Searches"
                                                                   disabled={ this.state.copy_move_ButtonsDisabled }
                                                                   onClick={ this._deleteSearches_Clicked_BindThis }
                                                            />
                                                        </Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component>
                                                        { ( this.state.copy_move_ButtonsDisabled ) ? (
                                                            // overlay when button is disabled to show tooltip
                                                            <Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component
                                                                title={
                                                                    <span>
                                                                        Click here to delete the selected searches.
                                                                    </span>
                                                                }
                                                                { ...limelight_Tooltip_React_Extend_Material_UI_Library__Main__Common_Properties__For_FollowMousePointer() }
                                                            >
                                                                <div
                                                                    style={ {
                                                                        position: "absolute",
                                                                        left: 0,
                                                                        right: 0,
                                                                        top: 0,
                                                                        bottom: 0
                                                                    } }
                                                                ></div>
                                                            </Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component>
                                                        ) : null }
                                                    </div>

                                                    <span> </span>

                                                    {/*  Bulk set/update tags on Searches */ }

                                                    <div style={ { position: "relative", display: "inline-block" } }>
                                                        <Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component
                                                            title={
                                                                <span>
                                                                    Click here to add/remove tags on the selected
                                                                    searches.
                                                                </span>
                                                            }
                                                            { ...limelight_Tooltip_React_Extend_Material_UI_Library__Main__Common_Properties__For_FollowMousePointer() }
                                                        >
                                                            <input type="button" value="Tag Searches"
                                                                   disabled={ this.state.copy_move_ButtonsDisabled }
                                                                   onClick={ this._bulk_set_update_TagsOnSearches_BindThis }
                                                            />
                                                        </Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component>
                                                        { ( this.state.copy_move_ButtonsDisabled ) ? (
                                                            // overlay when button is disabled to show tooltip
                                                            <Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component
                                                                title={
                                                                    <span>
                                                                        Click here to add/remove tags on the selected
                                                                        searches.
                                                                    </span>
                                                                }
                                                                { ...limelight_Tooltip_React_Extend_Material_UI_Library__Main__Common_Properties__For_FollowMousePointer() }
                                                            >
                                                                <div
                                                                    style={ {
                                                                        position: "absolute",
                                                                        left: 0,
                                                                        right: 0,
                                                                        top: 0,
                                                                        bottom: 0
                                                                    } }
                                                                ></div>
                                                            </Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component>
                                                        ) : null }
                                                    </div>

                                                    <span> </span>

                                                    {/*  Manage ALL Tags in Project  */ }

                                                    <div style={ { position: "relative", display: "inline-block" } }>
                                                        <Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component
                                                            title={
                                                                <span>
                                                                    Click here to manage tags on the project.
                                                                </span>
                                                            }
                                                            { ...limelight_Tooltip_React_Extend_Material_UI_Library__Main__Common_Properties__For_FollowMousePointer() }
                                                        >
                                                            <input type="button" value="Manage Tags"
                                                                   onClick={ this._manageTagsInProject_BindThis }
                                                            />
                                                        </Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component>
                                                    </div>

                                                    <span> </span>

                                                    {/*  Move Searches */ }
                                                    {/*

                                                        NO Longer support "Move Searches


                                                    <div style={ { position: "relative", display: "inline-block" } }>
                                                        <input type="button" value="Move Searches"
                                                               disabled={ this.state.copy_move_ButtonsDisabled }
                                                               onClick={ this._moveSearches_Clicked_BindThis }
                                                        />
                                                        { ( this.state.copy_move_ButtonsDisabled ) ? (
                                                            // overlay when button is disabled to show tooltip
                                                            <div
                                                                style={ { position: "absolute", left: 0, right: 0, top: 0, bottom: 0 } }
                                                                title = "Click here to copy the selected searches to another project."
                                                            ></div>
                                                        ): null }
                                                    </div>

                                                    <span> </span>

                                                    */ }

                                                    {/*  Organize Searches */ }
                                                    <div style={ { position: "relative", display: "inline-block" } }>
                                                        <Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component
                                                            title={
                                                                limelight__TooltipAddition_Component_ControlClick_OR_CommandClick_ToOpenInNewTab()
                                                            }
                                                            { ...limelight_Tooltip_React_Extend_Material_UI_Library__Main__Common_Properties__For_FollowMousePointer() }
                                                        >
                                                            <input
                                                                type="button"
                                                                value="Organize Searches"
                                                                onClick={ this._organizeSearchesButton_Clicked_BindThis }
                                                            />
                                                        </Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component>
                                                    </div>

                                                    <span> </span>

                                                    {/*  Open Set Filter Overrides Overlay  */ }
                                                    <div style={ { position: "relative", display: "inline-block" } }>
                                                        <Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component
                                                            title={
                                                                <span>
                                                                    Click here to set custom cutoffs for all searches..
                                                                </span>
                                                            }
                                                            { ...limelight_Tooltip_React_Extend_Material_UI_Library__Main__Common_Properties__For_FollowMousePointer() }
                                                        >
                                                            <input type="button" value="Filter Overrides"
                                                                   onClick={ this._openFilterOverridesOverlay_Clicked_BindThis }
                                                            />
                                                        </Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component>
                                                    </div>
                                                </>
                                            ) : null }
                                        </React.Fragment>
                                    ) : null }
                                </>

                            ) : null }
                        </div>

                    ) : null }

                    {/*  Filter Searches on User Input */ }

                    <div style={ { marginBottom: 10 } }>

                        { ( ! this.state.showNoSearchesMessage_NoSearchesLoadedFromServer ) ? (

                            <div style={ { marginBottom: 10 } }>
                                <span
                                    style={ { whiteSpace: "nowrap", fontWeight: "bold", fontSize: 18 } }
                                >Verbose view: </span>
                                <Tooltip__green_question_mark_in_circle__tooltip_on_hover__Component
                                    title={
                                        tooltip__green_question_mark_in_circle__tooltip_on_hover__COMMON_MESSAGE_Search_Tags_VerboseView_Checkbox_react_component()
                                    }
                                />
                                    <span> </span>
                                    <span>
                                        <input
                                            type="checkbox"
                                            checked={ this.state.show_SearchTag_Categories }
                                            onChange={ event => {
                                                const show_SearchTag_Categories = event.target.checked

                                                this.setState({ show_SearchTag_Categories })

                                                Search_DisplayVerbose_Value_StoreRetrieve_In_SessionStorage.save_Value(show_SearchTag_Categories)
                                            }}
                                        />
                                    </span>
                                </div>

                        ) : null }

                        {/*  Filter Searches: User Input: Filter On search name, search id, and search tags  */}

                        { ( ! this.state.showNoSearchesMessage_NoSearchesLoadedFromServer ) ? (

                            <div>
                                <span
                                    style={ { whiteSpace: "nowrap", fontWeight: "bold", fontSize: 18 } }
                                >Filter on Search Name or Id: </span>
                                <input
                                    value={ this._searchName_SearchId_Filter_UserInput }
                                    onChange={ event => {
                                        this._searchName_SearchId_Filter_UserInput = event.target.value

                                        this._searchesAndFolders_Update_FilterOnSearchTags()

                                        this.setState({ force_Rerender: {} })

                                        this._projectPage_SearchesSection_ROOT_Container_SessionStorage_SaveGet.
                                        update_SearchName_SearchId_FilterValue({ updated_SearchName_SearchId_FilterValue: this._searchName_SearchId_Filter_UserInput })
                                    }}
                                />
                            </div>
                        ) : null }

                        { ( ! this.state.use_Advanced_TagFilter ) && this.state.search_Tags_SelectSearchTags_Component_SearchTagData_Root && this.state.search_Tags_SelectSearchTags_Component_SearchTagData_Root.searchTag_Array.length > 0 ? (

                            <div
                                style={ { display: "grid", gridTemplateColumns: "min-content auto", marginTop: 3 } }
                            >
                                <div style={ { marginRight: 10, marginTop: 5 } }>  {/*  marginTop to vertical align label with tag text  */}
                                    <div style={ { whiteSpace: "nowrap", fontWeight: "bold", fontSize: 18 } }>
                                        Filter On Tags:
                                    </div>
                                    {/*  Switch to the Advanced grouped filter ( seeds from the basic selection, then clears basic )  */}
                                    <div style={ { marginTop: 8 } }>
                                        <button
                                            type="button"
                                            onClick={ () => { this._switchTo_Advanced_TagFilter() } }
                                            style={ { cursor: "pointer", whiteSpace: "nowrap" } }
                                        >
                                            Use Advanced tag filter
                                        </button>
                                    </div>
                                </div>
                                <div style={ { minWidth: 200 } }>

                                    <Search_Tags_SelectSearchTags_Component
                                        searchTagData_Root={ this.state.search_Tags_SelectSearchTags_Component_SearchTagData_Root }
                                        search_Tags_Selections_Object={ this._search_Tags_Selections_Object }
                                        searchesPerTagId_Map={ this._searchesPerTagId_Map }
                                        searchTagsSelected_Changed_Callback={ (params) => {

                                            this._search_Tags_Selections_Object = params.search_Tags_Selections_Object

                                            this._searchesAndFolders_Update_FilterOnSearchTags()

                                            this.setState({ force_Rerender: {} })

                                            this._projectPage_SearchesSection_ROOT_Container_SessionStorage_SaveGet.
                                            update_SearchTagIds_Selected({ updated_SearchTagIds_Selected: this._search_Tags_Selections_Object })
                                        } }
                                    />

                                </div>

                            </div>

                        ) : null }

                        {/*  Advanced ( grouped CNF ) tag filter -- shown ( instead of the basic filter ) below the
                             search-name/id input, seeded from the basic selection.  The "Filtering on tags:" summary
                             is rendered further down in the shared "filter-on-tags--currently-filtering" block.  */}

                        { this.state.use_Advanced_TagFilter && this.state.search_Tags_SelectSearchTags_Component_SearchTagData_Root && this.state.search_Tags_SelectSearchTags_Component_SearchTagData_Root.searchTag_Array.length > 0 ? (

                            <div style={ { marginTop: 10 } }>
                                {/*  "Use basic tag filter" button at the top of the advanced area  */}
                                <div style={ { marginBottom: 10 } }>
                                    <button
                                        type="button"
                                        onClick={ () => { this._switchTo_Basic_TagFilter() } }
                                        style={ { cursor: "pointer" } }
                                    >
                                        Use basic tag filter
                                    </button>
                                </div>

                                <Tag_Filter_Expression_Builder_Grouped_Component
                                    key={ "advanced-tag-filter-builder-" + this._advanced_Builder_RemountCounter }
                                    searchTagData_Root={ this.state.search_Tags_SelectSearchTags_Component_SearchTagData_Root }
                                    searchTags_TagLookupMaps={ this._searchTags_TagLookupMaps }
                                    searchesPerTagId_Map={ this._searchesPerTagId_Map }
                                    initial_Groups={ this._advanced_TagFilter_InitialSeed }
                                    initial_BetweenGroups_Operator={ this._advanced_TagFilter_Initial_BetweenOperator }
                                    expression_Changed_Callback={ ( expression: Tag_Filter_Expression_Builder_Grouped_Component__Expression ) => {

                                        //  Keep the seed fields in sync ( for remount + the summary preview ), persist, and re-run filtering
                                        this._advanced_TagFilter_InitialSeed = expression.groups.map( g => ( { groupOperator: g.groupOperator, literals: g.literals.map( l => ( { tagId: l.tagId, negated: l.negated } ) ) } ) )
                                        this._advanced_TagFilter_Initial_BetweenOperator = expression.betweenGroups_Operator

                                        window.setTimeout( ()=> { 	try {

                                            this._save_Advanced_TagFilter_ToSessionStorage( this._advanced_TagFilter_InitialSeed, this._advanced_TagFilter_Initial_BetweenOperator )
                                            this._searchesAndFolders_Update_FilterOnSearchTags()
                                            this.setState({ force_Rerender: {} })

                                        } catch (e) { reportWebErrorToServer.reportErrorObjectToServer({errorException: e}); throw e }
                                        }, 10 )
                                    } }
                                />
                            </div>

                        ) : null }

                        {/*  Display "Filtering On" to show what search name, search id, and search tags filtering on  */}

                        { this._searchName_SearchId_Filter_UserInput.length > 0
                            || ( ( ! this.state.use_Advanced_TagFilter ) && this._search_Tags_Selections_Object.is_any_selections() )
                            || ( this.state.use_Advanced_TagFilter && this._isAdvanced_TagFilter_Active() ) ? (

                            <div
                                className=" filter-on-tags--currently-filtering "
                                style={ { marginTop: 20, marginBottom: 15, padding: 10 } }
                            >
                                { this._searchName_SearchId_Filter_UserInput.length > 0 ? (  //  User Input value
                                    <div  //  Add marginBottom if also have Search Tags to display ( basic OR advanced tag filter )
                                        style={ { marginBottom : ( this._search_Tags_Selections_Object.is_any_selections() || ( this.state.use_Advanced_TagFilter && this._isAdvanced_TagFilter_Active() ) ) ? 5 : null } }
                                    >
                                        <span
                                            style={ { fontWeight: "bold", fontSize: 18, whiteSpace: "nowrap" } }
                                        >Filtering on text: </span>
                                        <span>
                                            { this._searchName_SearchId_Filter_UserInput }
                                        </span>
                                        <span> </span>
                                        <Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component
                                            title={
                                                <span>
                                                    Clear text filters
                                                </span>
                                            }
                                            { ...limelight_Tooltip_React_Extend_Material_UI_Library__Main__Common_Properties__For_FollowMousePointer() }
                                        >
                                            <span
                                                className=" fake-link "
                                                style={ { fontSize: 10 } }
                                                onClick={ event => {

                                                    this._searchName_SearchId_Filter_UserInput = "";

                                                    this._searchesAndFolders_Update_FilterOnSearchTags()

                                                    this.setState({ force_Rerender: {} })

                                                    this._projectPage_SearchesSection_ROOT_Container_SessionStorage_SaveGet.
                                                    update_SearchName_SearchId_FilterValue({ updated_SearchName_SearchId_FilterValue: this._searchName_SearchId_Filter_UserInput })
                                                }}
                                            >
                                                clear
                                            </span>
                                        </Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component>
                                    </div>
                                ) : null }

                                { ( ! this.state.use_Advanced_TagFilter ) && this._search_Tags_Selections_Object.is_any_selections() ? (

                                    <div
                                        style={ { display: "grid", gridTemplateColumns: "min-content 1fr" } }
                                    >
                                        <div>
                                            <div>
                                                <span style={ { fontSize: 18, fontWeight: "bold", whiteSpace: "nowrap", marginRight: 5 }}
                                                >
                                                    Filtering on tags:
                                                </span>
                                            </div>
                                            <div style={ { fontSize: 10 } }>
                                                <Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component
                                                    title={
                                                        <span>
                                                            Clear tag filters
                                                        </span>
                                                    }
                                                    { ...limelight_Tooltip_React_Extend_Material_UI_Library__Main__Common_Properties__For_FollowMousePointer() }
                                                >
                                                    <span
                                                        className=" fake-link "
                                                        style={ { fontSize: 10 } }
                                                        onClick={ () => {

                                                            this._search_Tags_Selections_Object = Search_Tags_Selections_Object.createEmptyInstance()

                                                            this._searchesAndFolders_Update_FilterOnSearchTags()

                                                            this.setState({ force_Rerender: {} })

                                                            this._projectPage_SearchesSection_ROOT_Container_SessionStorage_SaveGet.
                                                            update_SearchTagIds_Selected({ updated_SearchTagIds_Selected: this._search_Tags_Selections_Object })
                                                        } }
                                                    >
                                                        clear
                                                    </span>
                                                </Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component>
                                            </div>
                                        </div>
                                        <div>
                                            <Search_Tags_SelectSearchTags_DisplaySelectedTagsAndCategories_Component
                                                searchTagData_Root={ this.state.search_Tags_SelectSearchTags_Component_SearchTagData_Root }
                                                search_Tags_Selections_Object={ this._search_Tags_Selections_Object }
                                                searchesPerTagId_Map={ this._searchesPerTagId_Map }
                                                clearSelection_Callback={ () => {

                                                    this._search_Tags_Selections_Object = Search_Tags_Selections_Object.createEmptyInstance()

                                                    this._searchesAndFolders_Update_FilterOnSearchTags()

                                                    this.setState({ force_Rerender: {} })

                                                    this._projectPage_SearchesSection_ROOT_Container_SessionStorage_SaveGet.
                                                    update_SearchTagIds_Selected({ updated_SearchTagIds_Selected: this._search_Tags_Selections_Object })
                                                } }
                                            />
                                        </div>
                                    </div>
                                ) : null }

                                {/*  Advanced ( grouped CNF ) tag filter summary -- same shared block as "Filtering on text:"  */}
                                { this.state.use_Advanced_TagFilter && this._isAdvanced_TagFilter_Active() ? (

                                    <div
                                        style={ { display: "grid", gridTemplateColumns: "min-content 1fr" } }
                                    >
                                        <div>
                                            <div>
                                                <span style={ { fontSize: 18, fontWeight: "bold", whiteSpace: "nowrap", marginRight: 5 }}
                                                >
                                                    Filtering on tags:
                                                </span>
                                            </div>
                                            <div style={ { fontSize: 10 } }>
                                                <Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component
                                                    title={
                                                        <span>
                                                            Clear the tag filter &mdash; remove all groups and tags.
                                                        </span>
                                                    }
                                                    { ...limelight_Tooltip_React_Extend_Material_UI_Library__Main__Common_Properties__For_FollowMousePointer() }
                                                >
                                                    <span
                                                        className=" fake-link "
                                                        style={ { fontSize: 10 } }
                                                        onClick={ () => { this._clearAdvancedTagFilter() } }
                                                    >
                                                        clear
                                                    </span>
                                                </Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component>
                                            </div>
                                        </div>
                                        <div>
                                            <Tag_Filter_Expression_Preview_Component
                                                groups={ this._advanced_TagFilter_InitialSeed }
                                                betweenGroups_Operator={ this._advanced_TagFilter_Initial_BetweenOperator }
                                                searchTags_TagLookupMaps={ this._searchTags_TagLookupMaps }
                                                searchesPerTagId_Map={ this._searchesPerTagId_Map }
                                            />
                                        </div>
                                    </div>
                                ) : null }

                                {/*  Count of searches that passed the active filters ( bottom of the box )  */}
                                <div style={ { marginTop: 10 } }>
                                    <b>{ this._filtered_Searches_PassedCount() }</b>
                                    { this._filtered_Searches_PassedCount() === 1 ? " search passes the filters" : " searches pass the filters" }
                                </div>
                            </div>
                        ) : null }

                        {/*  Separator line between the tag-filter area and the searches list  */}

                        { this.state.search_Tags_SelectSearchTags_Component_SearchTagData_Root && this.state.search_Tags_SelectSearchTags_Component_SearchTagData_Root.searchTag_Array.length > 0 ? (

                            <div style={ { marginTop: 20, paddingTop: 14, borderTopWidth: 1, borderTopStyle: "solid", borderTopColor: "#dddddd", marginBottom: 12 } }></div>

                        ) : null }
                    </div>

                    { ( this.state.showNoSearchesMessage_NoSearchesLoadedFromServer ) ? (

                        <div style={ { marginBottom: 20 } }>
                            No searches in this project.
                        </div>

                    ) : ( this.state.showNoSearchesMessage_NoSearches_AfterPossibleFiltering ) ? (

                        <div style={ { marginBottom: 20, marginTop: 20 } }>

                            <span>
                                No searches in this project match current filters.
                            </span>

                            {/* Error Message broken out by what filtering on

                                    { this._searchName_SearchId_Filter_UserInput.length > 0 && this._searchTag_Filter_SelectedTagIds.size > 0 ? (
                                        <span>
                                            No searches in this project contain all the selected search tags and the filter text.
                                        </span>
                                    ) : this._searchName_SearchId_Filter_UserInput.length > 0 ? (
                                        <span>
                                        No searches in this project contain the filter text.
                                    </span>
                                    ) : this._searchTag_Filter_SelectedTagIds.size > 0 ? (
                                        <span>
                                            No searches in this project contain all the selected search tags.
                                        </span>
                                    ) : null }
                                    */}
                        </div>

                    ) : (
                        <React.Fragment>

                            <ProjectPage_SearchesSection_SearchesAndFoldersList_Component
                                projectIdentifier={ this.props.projectIdentifier }
                                force_Rerender_EmptyObjectReference={ this.props.force_Rerender_EmptyObjectReference }
                                force_ReloadFromServer_EmptyObjectReference={ this.props.force_ReloadFromServer_EmptyObjectReference }

                                forceReplace_search_Selected_InProgress={ this._forceUpdate_search_Selected_InProgress }

                                show_SearchTag_Categories={ this.state.show_SearchTag_Categories }
                                searchesSearchTagsFolders_Result_Root={ this._searchesSearchTagsFolders_Result_Root }
                                search_Tags_DisplaySearchTags_UnderSearchName_Component_SearchTagData_Root={ this.state.search_Tags_SelectSearchTags_Component_SearchTagData_Root }
                                projectSearchIds_ToDisplay_FilteredIfNeeded__Null_IfNoFiltering={ this.state.projectSearchIds_ToDisplay_FilteredIfNeeded__Null_IfNoFiltering }   //  null if no filtering
                                folderIds_ToDisplay_FilteredIfNeeded__Null_IfNoFiltering={ this.state.folderIds_ToDisplay_FilteredIfNeeded__Null_IfNoFiltering }          //  null if no filtering
                                expand_All_Folders__ShowSearchDetailsTo_Global_Force={ this.state.expand_All_Folders__ShowSearchDetailsTo_Global_Force }
                                dataPages_LoggedInUser_CommonObjectsFactory_ForSearchDetails={ this.props.dataPages_LoggedInUser_CommonObjectsFactory_ForSearchDetails}
                                projectPage_SearchesAdmin={ this.props.projectPage_SearchesAdmin }
                                callback_updateSelected_Searches={ this._callback_updateSelected_Searches_BindThis }
                                projectPage_SearchesSection_ROOT_Container_SessionStorage_SaveGet={ this._projectPage_SearchesSection_ROOT_Container_SessionStorage_SaveGet }
                                callback_SearchChanged={ this._callback_SearchChanged_BindThis }
                                callback_SearchDeleted={ this._callback_SearchDeleted_BindThis }
                                callback_FolderRenamedOrDeleted={ this._callback_FolderRenamedOrDeleted_BindThis }

                                searchDetails_AllUsers__GetDataFromServer_Result__Root__HolderObject={ this.props.searchDetails_AllUsers__GetDataFromServer_Result__Root__HolderObject  }
                                update_force_ReRender_EmptyObjectReference_Callback={ this.props.update_force_ReRender_EmptyObjectReference_Callback }
                            />

                            <div style={ { marginBottom: 10, whiteSpace: "nowrap" } }>

                                {/*  compare Scan File To Searches */}
                                <div style={ { position: "relative", display: "inline-block" } }>
                                    <Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component
                                        title={
                                            limelight__TooltipAddition_Component_ControlClick_OR_CommandClick_ToOpenInNewTab()
                                        }
                                        { ...limelight_Tooltip_React_Extend_Material_UI_Library__Main__Common_Properties__For_FollowMousePointer() }
                                    >
                                        <input type="button" value="Compare by Scans"
                                               disabled={ this.state.compareButtonsDisabled }
                                               onClick={ this._compare_Scan_File_to_Searches_Clicked_BindThis }
                                        />
                                    </Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component>
                                    { ( this.state.compareButtonsDisabled ) ? (
                                        // overlay when button is disabled to show tooltip
                                        <Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component
                                            title={
                                                <span>
                                                    Select 2 or more searches to compare searches
                                                </span>
                                            }
                                            { ...limelight_Tooltip_React_Extend_Material_UI_Library__Main__Common_Properties__For_FollowMousePointer() }
                                        >
                                            <div
                                                style={ { position: "absolute", left: 0, right: 0, top: 0, bottom: 0 } }
                                            ></div>
                                        </Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component>
                                    ): null }
                                </div>

                                <span > </span>

                                {/*  compare QC */}
                                <div style={ { position: "relative", display: "inline-block" } }>
                                    <Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component
                                        title={
                                            limelight__TooltipAddition_Component_ControlClick_OR_CommandClick_ToOpenInNewTab()
                                        }
                                        { ...limelight_Tooltip_React_Extend_Material_UI_Library__Main__Common_Properties__For_FollowMousePointer() }
                                    >
                                        <input type="button" value="Compare Stats/QC View"
                                               disabled={ this.state.compareButtonsDisabled }
                                               onClick={ this._compare_Stats_QC_Clicked_BindThis }
                                        />
                                    </Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component>
                                    { ( this.state.compareButtonsDisabled ) ? (
                                        // overlay when button is disabled to show tooltip
                                        <Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component
                                            title={
                                                <span>
                                                    Select 2 or more searches to compare searches
                                                </span>
                                            }
                                            { ...limelight_Tooltip_React_Extend_Material_UI_Library__Main__Common_Properties__For_FollowMousePointer() }
                                        >
                                            <div
                                                style={ { position: "absolute", left: 0, right: 0, top: 0, bottom: 0 } }
                                            ></div>
                                        </Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component>
                                    ): null }
                                </div>

                                <span > </span>

                                {/*  compare peptide */}
                                <div style={ { position: "relative", display: "inline-block" } }>
                                    <Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component
                                        title={
                                            limelight__TooltipAddition_Component_ControlClick_OR_CommandClick_ToOpenInNewTab()
                                        }
                                        { ...limelight_Tooltip_React_Extend_Material_UI_Library__Main__Common_Properties__For_FollowMousePointer() }
                                    >
                                        <input type="button" value="Compare Peptide View"
                                               disabled={ this.state.compareButtonsDisabled }
                                               onClick={ this._compare_Peptides_Clicked_BindThis }
                                        />
                                    </Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component>
                                    { ( this.state.compareButtonsDisabled ) ? (
                                        // overlay when button is disabled to show tooltip
                                        <Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component
                                            title={
                                                <span>
                                                    Select 2 or more searches to compare searches
                                                </span>
                                            }
                                            { ...limelight_Tooltip_React_Extend_Material_UI_Library__Main__Common_Properties__For_FollowMousePointer() }
                                        >
                                            <div
                                                style={ { position: "absolute", left: 0, right: 0, top: 0, bottom: 0 } }
                                            ></div>
                                        </Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component>
                                    ): null }
                                </div>

                                <span > </span>

                                {/*  compare Protein */}
                                <div style={ { position: "relative", display: "inline-block" } }>
                                    <Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component
                                        title={
                                            limelight__TooltipAddition_Component_ControlClick_OR_CommandClick_ToOpenInNewTab()
                                        }
                                        { ...limelight_Tooltip_React_Extend_Material_UI_Library__Main__Common_Properties__For_FollowMousePointer() }
                                    >
                                        <input type="button" value="Compare Protein View"
                                               disabled={ this.state.compareButtonsDisabled || ( ! this.state.allSearches_InSelection_ContainProteins ) }
                                               onClick={ this._compare_Proteins_Clicked_BindThis }
                                        />
                                    </Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component>
                                    { ! this.state.allSearches_InSelection_ContainProteins ? (
                                            // overlay when button is disabled to show tooltip
                                            <Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component
                                                title={
                                                    <span>
                                                        Compare proteins is not available since one or more selected searches does not have proteins
                                                    </span>
                                                }
                                                { ...limelight_Tooltip_React_Extend_Material_UI_Library__Main__Common_Properties__For_FollowMousePointer() }
                                            >
                                                <div
                                                    style={ { position: "absolute", left: 0, right: 0, top: 0, bottom: 0 } }
                                                ></div>
                                            </Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component>
                                    ) : ( this.state.compareButtonsDisabled ) ? (
                                        // overlay when button is disabled to show tooltip
                                        <Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component
                                            title={
                                                <span>
                                                    Select 2 or more searches to compare searches
                                                </span>
                                            }
                                            { ...limelight_Tooltip_React_Extend_Material_UI_Library__Main__Common_Properties__For_FollowMousePointer() }
                                        >
                                            <div
                                                style={ { position: "absolute", left: 0, right: 0, top: 0, bottom: 0 } }
                                            ></div>
                                        </Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component>
                                    ) : null }
                                </div>

                                <span > </span>

                                {/*  compare Mod */}
                                <div style={ { position: "relative", display: "inline-block" } }>
                                    <Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component
                                        title={
                                            limelight__TooltipAddition_Component_ControlClick_OR_CommandClick_ToOpenInNewTab()
                                        }
                                        { ...limelight_Tooltip_React_Extend_Material_UI_Library__Main__Common_Properties__For_FollowMousePointer() }
                                    >
                                        <input type="button" value="Compare Mod View"
                                               disabled={ this.state.compareButtonsDisabled }
                                               onClick={ this._compare_Mods_Clicked_BindThis }
                                        />
                                    </Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component>
                                    { ( this.state.compareButtonsDisabled ) ? (
                                        // overlay when button is disabled to show tooltip
                                        <Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component
                                            title={
                                                <span>
                                                    Select 2 or more searches to compare searches
                                                </span>
                                            }
                                            { ...limelight_Tooltip_React_Extend_Material_UI_Library__Main__Common_Properties__For_FollowMousePointer() }
                                        >
                                            <div
                                                style={ { position: "absolute", left: 0, right: 0, top: 0, bottom: 0 } }
                                            ></div>
                                        </Limelight_Tooltip_React_Extend_Material_UI_Library__Main_Tooltip_Component>
                                    ): null }
                                </div>
                            </div>
                        </React.Fragment>
                    )}
                </div>
            )
        );
    }

}
